import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import STATISTICS_API from 'api/statisticsApi';
import DateFilter from '@common-components/date-filter/DateFilter';
import DateRange from '@common-components/date-range/DateRange';
import StackedBar from '@common-components/graphs/stacked-bar/StackedBar';
import { useFetch } from '@hooks/useStatApi';
import Loader from '@common-components/loader/Loader';

export default function StackBarChart({ batchNo , supplierId: supplierIdProp }) {
  const today = dayjs().startOf('day');
  const oneWeekAgo = today.subtract(1, 'week');
  const supplierId =  supplierIdProp || localStorage.getItem('supplierId');
  const shouldFetch = supplierId !== null; // will be null initially, but maybe undefined is also meaningful

  const [dateRange, setDateRange] = useState(`${oneWeekAgo.format('YYYY-MM-DD')} - ${today.format('YYYY-MM-DD')}`);
  const [selectedFilter, setSelectedFilter] = useState('1W');
const [mFilter, setMfilter] = useState()

  const [startDate, endDate] = dateRange
    ? dateRange.split(' - ').map(date => dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
    : [null, null];

  const params = {
    startDate,
    endDate,
    supplierId,
  };

  // Only fetch supplier info if batchNo is not present
  const { data: info, isLoading: isFilletLoading, refetch } = useFetch(
    "fetchInfo",
    STATISTICS_API.filletInfo,
    (!batchNo && shouldFetch) ? params : null
  );

  const { data: batchData, isLoading: isBatchLoading, isFetching: isBatchFetching,
    refetch: refetchBatch } = useFetch(
    "fetchBAtchInfo",
    STATISTICS_API.getFilletInfobatch,
    batchNo ? { batchNo: batchNo, startDate, endDate } : null
  );

  const formattedData = batchData?.data
    ? [{
        state: "",
        totalFillet: batchData?.data.totalFillet,
        upgradedPercentage: batchData?.data.upgraded.percentage !=0 ? batchData?.data.upgraded.percentage : null,
        noChangePercentage: batchData?.data.noChange.percentage !=0 ? batchData?.data.noChange.percentage : null,
        downGradedPercentage: batchData?.data.downgraded.percentage !=0 ? batchData?.data.downgraded.percentage : null,
        upgraded: batchData?.data.upgraded.count != 0 ? batchData?.data.upgraded.count : null,
        noChange: batchData?.data.noChange.count != 0 ? batchData?.data.noChange.count : null,
        downGraded: batchData?.data.downgraded.count != 0 ? batchData?.data.downgraded.count : null,
      }]    
    : [{
        state: "",
        totalFillet: info?.data.totalFillet,
        upgradedPercentage: info?.data.upgraded.percentage !=0 ? info?.data.upgraded.percentage : null,
        noChangePercentage: info?.data.noChange.percentage !=0 ? info?.data.noChange.percentage : null,
        downGradedPercentage: info?.data.downgraded.percentage !=0 ? info?.data.downgraded.percentage : null, // <--- ADD condition for downGradedPercentage
        upgraded: info?.data.upgraded.count != 0 ? info?.data.upgraded.count : null,
        noChange: info?.data.noChange.count != 0 ? info?.data.noChange.count : null, // <--- ADD condition for noChange
        downGraded: info?.data.downgraded.count != 0 ? info?.data.downgraded.count : null,
      }];

  console.log(formattedData);
  

  const handleQuickFilter = (filter) => {
    setSelectedFilter(filter);
    setMfilter(filter);

    const today = dayjs().startOf('day');
    let fromDate = today.format('YYYY-MM-DD');

    switch (filter) {
      case '1W': fromDate = today.subtract(1, 'week').format('YYYY-MM-DD'); break;
      case '1M': fromDate = today.subtract(1, 'month').format('YYYY-MM-DD'); break;
      case '1Q': fromDate = today.subtract(3, 'month').format('YYYY-MM-DD'); break;
      case '1Y': fromDate = today.subtract(1, 'year').format('YYYY-MM-DD'); break;
      case '2Y': fromDate = today.subtract(2, 'year').format('YYYY-MM-DD'); break;
      default: break;
    }

    setDateRange(`${fromDate} - ${today.format('YYYY-MM-DD')}`);
  };
  


  useEffect(() => {
    if (dateRange) refetch();
  }, [dateRange, refetch]);
console.log("batchData", isFilletLoading);
 

  return (
    <div className='dx-card responsive-paddings mt-3 custom-graphs'>
      <div className='grid lg:grid-cols-3 grid-cols-1 space-y-3 lg:space-y-0 mb-4'>
        <div className='flex justify-between'>
          <p className="mb-0 text-xl font-medium">
            {batchData?.data ? "Fillet Information" : "Fillet Information"}
          </p>
          <p className="mb-0 text-lg font-medium">
            Total Fillet: {formattedData[0]?.totalFillet}
          </p>
        </div>
        <div className='ml-12'>
          <DateFilter mFilter={mFilter} onFilterChange={handleQuickFilter} selectedFilter={selectedFilter} />
        </div>
        <DateRange
          onDateChange={(newRange) => {
            setDateRange(newRange);
            setSelectedFilter(null); // <--- RESET selectedFilter
          }}
          dateRange={dateRange}
        />
      </div>
      {/* Loader only shows if loading and no cached data.
      If API returns no data and it's cached, "No Data Found" is shown. */}
      {(!formattedData[0]?.totalFillet && (isBatchFetching || isFilletLoading)) ? (
        <div className="flex justify-center items-center">
         <Loader />
        </div>
      ) : (
        formattedData[0]?.totalFillet ? (
          <>
            <StackedBar data={formattedData} />
            <div className="flex justify-center mt-4 space-x-4">
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-green-500"></div>
                <span className="text-sm">Upgrade</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-yellow-500"></div>
                <span className="text-sm">No Change</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-red-500"></div>
                <span className="text-sm">Downgrade</span>
              </div>
            </div>
          </>
        ) : (
          <div className="text-center no-data-text p-8">
            No Data Found
          </div>
        )
      )}
    </div>
  );
}
